import "./PaymentsActivityFilterForm.scss";
import { Checkbox, Flex, Typography } from "antd";
import { TablePopoverFooterButtons } from "molecules/filters/TableFilter/TablePopoverFooterButtons";
import {
    initialSources,
    initialStatuses,
    transactionSourceValues,
    transactionStatusToText,
    usePaymentsActivityStatusFilters,
} from "./usePaymentsActivityStatusFilters";
import { useFeatureFlag } from "utils/useFeatureFlag";
import { useShallow } from "zustand/shallow";

const { Title } = Typography;

/** Properties for bulk request filtering form. */
interface PaymentsActivityFilterFormProps {
    /** Callback for closing filter popover. */
    readonly onClose: () => void;
}

/** Payment activity filtering form, offering source and status filters. */
export const PaymentsActivityFilterForm = ({ onClose }: PaymentsActivityFilterFormProps) => {
    const { sources, statuses, toggleStatus, toggleSource, resetFilters } = usePaymentsActivityStatusFilters(
        useShallow((state) => ({
            sources: state.sources,
            statuses: state.statuses,
            toggleStatus: state.toggleStatus,
            toggleSource: state.toggleSource,
            resetFilters: state.resetFilters,
        })),
    );

    const hasBillPay = !!useFeatureFlag("bill-pay", false);
    const hasInsuranceProcessing = !!useFeatureFlag("insurance_processing", false);

    return (
        <Flex className="payments-activity-filter-form" vertical={true} gap="small">
            <header>
                <Title level={3} className="filter-statuses-header">
                    Statuses
                </Title>
            </header>
            {initialStatuses.map((singleStatus) => (
                <Checkbox
                    key={singleStatus}
                    checked={statuses.includes(singleStatus)}
                    onChange={(e) => toggleStatus(singleStatus, e.target.checked)}
                >
                    {transactionStatusToText[singleStatus]}
                </Checkbox>
            ))}
            <header>
                <Title level={3} className="filter-sources-header">
                    Sources
                </Title>
            </header>
            {initialSources.map((source) =>
                // Hide the Bill Pay check box if they don't have the feature
                (source !== "BillPay" || hasBillPay) &&
                // Hide the Insurance check box if they don't have the feature
                (source !== "DashboardInsurance" || hasInsuranceProcessing) ? (
                    <Checkbox
                        key={source}
                        checked={sources.includes(source)}
                        onChange={(e) => toggleSource(source, e.target.checked)}
                    >
                        {transactionSourceValues[source]}
                    </Checkbox>
                ) : null,
            )}

            <TablePopoverFooterButtons resetFilters={resetFilters} onClose={onClose} />
        </Flex>
    );
};
